import { addToRootSaga } from 'store';
import { call, takeLatest, put } from 'redux-saga/effects';
import { updateEventLimit, fetchProjectLimitData } from 'api/InternalToolsAPI';
import { addPositiveToast, addNegativeToast } from 'modules/toastContainer';
import * as actions from './actions';
import * as actionTypes from './actionTypes';

export function* updateCustomEventLimit({ requestData }) {
  const { projectId, customEventLimit, callback } = requestData;
  try {
    const updateLimitResponse = yield call(updateEventLimit, projectId, customEventLimit);
    yield put(actions.updateCustomEventLimitResponse(updateLimitResponse));
    const msg = 'Successfully updated Custom Event Limit!';
    callback();
    yield put(addPositiveToast(msg));
  } catch (error) {
    const message = `Something went wrong: ${error.message}`;
    yield put(addNegativeToast(message));
    yield put(actions.updateCustomEventLimitError(error.message));
  }
}

export function* getProjectLimitData({ requestData }) {
  const { projectId } = requestData;
  try {
    const projectDataResponse = yield call(fetchProjectLimitData, projectId);
    yield put(actions.fetchProjectLimitDataResponse(projectDataResponse));
  } catch (error) {
    yield put(actions.fetchProjectLimitDataError(error.message));
  }
}

addToRootSaga([
  takeLatest(actionTypes.UPDATE_CUSTOM_EVENT_LIMIT_REQUEST, updateCustomEventLimit),
  takeLatest(actionTypes.FETCH_PROJECT_LIMIT_DATA_REQUEST, getProjectLimitData),
]);
